export const apiUrl = process.env.REACT_APP_API_URL;
export const signalUrl = process.env.REACT_APP_SIGNAL_URL;

// export const apiUrl = "https://dev.airdesk.ai/api/"; //dev
// export const apiUrl = "https://api.airdesk.ai/";
export const stripeKey = "pk_live_nCPvNgCk0A9nZhTsBND4Mygx00CNm9kaGI";
export const inboxEmailDomain = "inbox.airdesk.ai";
//export const signalUrl = "http://192.168.129.71:5191"  //TODO
//export const signalUrl = "https://realtime-dev.airdesk.ai:8443"  //TODO Staging
// export const signalUrl = "https://airdesk-realtime.azurewebsites.net"  //TODO Prod